<template>
  <form-field-v2
    :label="label"
    :hint="hint"
    :error="error"
    :help="help"
    :disabled="disabled"
    :label-for="controlId"
    strong
  >
    <select
      :id="controlId"
      v-model="model"
      class="select-v2 w-full"
      :class="{ 'is-error': !!error }"
      :disabled="disabled"
      v-bind="$attrs"
      v-on="controlListeners"
    >
      <option v-if="placeholder" :value="null" disabled>
        {{ placeholder }}
      </option>
      <option
        v-for="(option, index) in options"
        :key="optionKey(option, index)"
        :value="option.value"
        :disabled="option.disabled"
      >
        {{ option.label }}
      </option>
    </select>
  </form-field-v2>
</template>

<script>
import FormFieldV2 from './FormFieldV2.vue';

let instanceCount = 0;

export default {
  name: 'SelectV2',
  components: { FormFieldV2 },
  inheritAttrs: false,
  props: {
    value: { type: [String, Number, Boolean, Object], default: null },
    options: { type: Array, default: () => [] },
    placeholder: { type: String, default: '' },
    label: { type: String, default: '' },
    hint: { type: String, default: '' },
    error: { type: String, default: '' },
    help: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    instanceCount += 1;
    return { instanceId: instanceCount };
  },
  computed: {
    controlId() {
      return this.$attrs.id || `select-v2-${this.instanceId}`;
    },
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
        this.$emit('change', value);
      },
    },
    controlListeners() {
      const listeners = { ...this.$listeners };
      delete listeners.input;
      delete listeners.change;
      return listeners;
    },
  },
  methods: {
    optionKey(option, index) {
      if (option.key !== undefined) return option.key;
      return typeof option.value === 'object' ? index : option.value;
    },
  },
};
</script>
